import { render, staticRenderFns } from "./newsList.vue?vue&type=template&id=75e9d714&scoped=true"
import script from "./newsList.vue?vue&type=script&setup=true&lang=js"
export * from "./newsList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./newsList.vue?vue&type=style&index=0&id=75e9d714&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e9d714",
  null
  
)

export default component.exports